import { Button, Divider, Form, FormInstance, Input, message, Modal, Select, Space, Switch, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const BlackListEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const { ...rest } = props;

    useEffect(() => {
        if (rest.isOpen) {
            switch (rest.viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    getBlackList();
                    break;
                case 2:
                    getBlackList();
                    break;
            }

        }
    }, [rest.isOpen])

    const setData = (record: any) => {
        if (record) {
            formRef.current?.setFieldsValue(record);
        }
        else {
            formRef.current?.resetFields();
        }
    }

    const getBlackList = () => {
        if (rest.blackListID) {
            var params = {
                blackListID: rest.blackListID
            };
            Server.Post(URL.BlackList.GetBlackList, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                }
            })
        }
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var params = values;
            Server.Post(URL.BlackList.SaveBlackList, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    return <Modal title={(rest.viewMode == 0 ? '新增' : '编辑') + "黑名单"} width={600} open={rest.isOpen} onCancel={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: 0, margin: 8 }}
        footer={
            <Space>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            labelCol={{
                xs: { span: 24 },
                sm: { span: 4 }
            }} wrapperCol={{
                xs: { span: 24 },
                sm: { span: 20 }
            }}>
            <Form.Item style={{ marginBottom: '5px' }} hidden label={'黑名单ID'} name={'blackListID'} initialValue={null}>
                <Input readOnly={rest.viewMode == 2} />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'客户名称'} name={'customerName'} initialValue={''}
                rules={[{ required: true, message: '请输入客户名称' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'黑名单等级'} name={'blackLevel'} initialValue={'1'}>
                <Select defaultValue={'1'}
                    placeholder={'选择黑名单等级'}
                    style={{ width: '100%' }}
                    options={[
                        { value: '1', label: '1级' },
                        { value: '2', label: '2级' },
                        { value: '3', label: '3级' },
                        { value: '4', label: '4级' },
                        { value: '5', label: '5级' },
                    ]}
                    showSearch
                    optionFilterProp="children"
                    filterOption={filterOption} />
            </Form.Item>
        </Form>
    </Modal>
};
export default BlackListEdit